function getOrDefault( obj = {}, path = [], defaultValue = null ) {
  if ( !Array.isArray( path ) ) {
    return getOrDefault( obj, path.split( '.' ), defaultValue );
  }
  while ( path.length && obj ) {
    obj = obj[path.shift()];
  }
  return obj;
}

function find( arr, predicate ) {
  if ( arr && arr.length ) {
    for ( let i = 0; i < arr.length; i++ ) {
      if ( predicate( arr[i] ) ) {
        return arr[i];
      }
    }
  }

  return { };
}

export const repositoryState = ( entityName, key ) => state => ( {
  items: key ? getOrDefault( state, [entityName, key, 'items'], [] ) : getOrDefault( state, [entityName, 'items'], [] )
} );

export const itemRepositoryState = ( entityName, predicate, key ) => state => ( {
  item: find( key ? getOrDefault( state, [entityName, key, 'items'], [] ) : getOrDefault( state, [entityName, 'items'], [] ), predicate )
} );

export const mappedRepositoryState = ( mappedName, entityName, key ) => state => ( {
  [mappedName]: repositoryState( entityName, key )( state ).items
} );